import { __extends } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { Button } from 'reactstrap';
import { config } from '../../../../_core/config';
import { createDebugLogger } from '../../../../_core/utils/app-utils';
import { I18nMsgNs } from '../../../../_core/utils/i18n-helpers';
import ExternalLink from './ExternalLink/ExternalLink';
import './Options.scss';
import { parseMarkdownOption } from './parse-markdown-option';
import { getClientConfig } from '../../../../_core/utils/app-storage';
var Msg = I18nMsgNs('Options');
var Options = /** @class */ (function (_super) {
    __extends(Options, _super);
    function Options(props) {
        var _this = _super.call(this, props) || this;
        _this.debug = createDebugLogger('Options');
        _this.state = {
            disabled: false,
            toggleShowMore: false,
        };
        /**
         * @param e
         * @param value
         * @param utterance "optional value used as actual utterance to goodbot over the
         *                   wire... Hidden in UI. Saved in message.meta container."
         */
        _this.submitValueAsChatMessage = function (e, value, utterance) {
            e.preventDefault();
            if (typeof _this.props.submitMessage === 'function') {
                _this.setState({ disabled: true });
                _this.props.submitMessage(value, null, { utterance: utterance });
                return;
            }
            console.warn("Unable to submit '".concat(value, "'"));
        };
        _this.handleShowMoreLess = function () {
            _this.setState({ toggleShowMore: !_this.state.toggleShowMore });
            _this.props.scrollToBottom();
        };
        return _this;
    }
    Options.prototype.render = function () {
        var _this = this;
        var _a = this.props, options = _a.options, disabled = _a.disabled, data = _a.data, message = _a.message;
        var BUTTON_LIMIT = getClientConfig().BUTTON_LIMIT;
        var B = config.css.B('-message-options');
        var authorType = message.authorType;
        var _maybeRenderExternalLink = function (label, idx) {
            if (!data || (typeof data === 'object' && !('url_buttons' in data))) {
                return null;
            }
            if (Object.keys(data.url_buttons)[0] === label) {
                var link = data.url_buttons[label];
                return (React.createElement(ExternalLink, { key: idx, title: label, description: link.description || '', url: link.url || '', image: link.image || '', disabled: disabled || _this.state.disabled, redirect: link.redirect || false, onClick: function (e) { return _this.submitValueAsChatMessage(e, label); } }));
            }
            else {
                return null;
            }
        };
        var renderedOptions = options, hiddenOptions = [];
        if (BUTTON_LIMIT && options.length > Number(BUTTON_LIMIT)) {
            renderedOptions = options.slice(0, Number(BUTTON_LIMIT));
            hiddenOptions = options.slice(Number(BUTTON_LIMIT));
        }
        var renderOption = function (optionInput, idx) {
            var _a = parseMarkdownOption(optionInput), label = _a.label, color = _a.color, customClassName = _a.customClassName, value = _a.value, img = _a.img;
            var externalLink = _maybeRenderExternalLink(label, idx);
            if (externalLink) {
                return externalLink;
            }
            return (React.createElement(Button, { key: idx, color: color, className: cn("".concat(B, "__button"), customClassName), onClick: function (e) { return _this.submitValueAsChatMessage(e, label, value); }, value: value, disabled: disabled || _this.state.disabled },
                img && React.createElement("img", { src: img, alt: "" }),
                label));
        };
        // prettier-ignore
        return (React.createElement("div", { className: cn(B), "data-author-type": authorType },
            renderedOptions.map(renderOption),
            this.state.toggleShowMore ? hiddenOptions.map(renderOption) : null,
            hiddenOptions.length > 0 && !disabled && !this.state.disabled ? React.createElement("div", { className: "".concat(B, "__show-more") }, React.createElement("span", { onClick: function () { return _this.handleShowMoreLess(); } }, this.state.toggleShowMore ? 'Zobrazit méně' : 'Zobrazit více')) : null));
    };
    Options.defaultProps = {
        disabled: false,
    };
    return Options;
}(React.Component));
export { Options };
export default Options;
